import { useIntl } from 'react-intl';
import { YES_NO_OPTIONS } from 'utils/constants';

export const ADDITIONAL_DETAILS_FIELD_NAMES = {
  anyParkedVehicles: 'anyParkedVehicles',
  anyPetsLiving: 'anyPetsLiving',
  anyEmergencyContacts: 'anyEmergencyContacts',
  needsAccesibleUnit: 'needsAccesibleUnit',
};

const useFields = () => {
  const intl = useIntl();

  return Object.values(ADDITIONAL_DETAILS_FIELD_NAMES).map((field) => ({
    id: 'choices',
    name: field,
    isAffordaPortalSpecific: true,
    label: intl.formatMessage({
      id: `afforda.documentation.applicationSubmission.${field}`,
    }),
    variant: 'buttonGroup',
    options: YES_NO_OPTIONS,
    rules: {
      required: true,
    },
    GridProps: { xs: 12 },
    direction: 'row',
  }));
};

export default useFields;
